import { makeStyles, Theme } from '@material-ui/core/styles';
export const useStyles = makeStyles((theme: Theme) => ({
  modal: {
    //marginTop: theme.spacing(10),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'auto',
  },
  title: {
    //margin: '0 0 24px',
    marginTop: theme.spacing(0.5),
    fontSize: 20,
    color: 'black',
  },
  notify: {
    '& .MuiTypography-body1 ': {
      fontSize: '14px',
    },
  },
  inputText: {
    width: '100%',
  },
  paper: {
    //marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
    padding: 15,
    width: '700px',
  },
  formControl: {
    width: '100%',
  },
  link: {
    //alignItems: 'flex-grow',
    marginRight: theme.spacing(1),
    display: 'flex',
    alignItems: 'flex-end',
  },
  margin: {
    margin: theme.spacing(1),
  },
  marginTop: {
    marginTop: theme.spacing(3),
  },
  footnote: {
    opacity: 0.5,
    margin: theme.spacing(1),
  },
  actionBtn: {
    width: '49%',
    boxShadow: 'none',
    textTransform: 'none',
    lineHeight: '36px',
    padding: `0 ${theme.spacing(3)}px`,
  },
  cancelButton: {
    width: '49%',
    boxShadow: 'none',
    textTransform: 'none',
    lineHeight: '36px',
    padding: `0 ${theme.spacing(3)}px`,
    //margin: theme.spacing(1),
    //color: theme.palette.getContrastText(blue[500]),
  },
}));
